"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isArray;
function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}